import React from 'react';
import { FaInstagram, FaEnvelope } from 'react-icons/fa';

const Header = () => {
    return (
        <div className="relative py-2 px-4 shadow-md overflow-hidden">

            {/* BACKGROUND IMAGE - terlihat jelas */}
            <div
                className="absolute inset-0 w-full h-full bg-no-repeat bg-cover bg-center pointer-events-none"
                style={{
                    backgroundImage: "url('/images/headerbg.png')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    opacity: 0.8, // Dinaikkan agar gambar terlihat jelas
                }}
            ></div>

            {/* OVERLAY WARNA - tipis saja agar gambar tetap terlihat */}
            <div
                className="absolute inset-0 w-full h-full pointer-events-none"
                style={{
                    backgroundColor: '#218284',
                    opacity: 0.45, // Diturunkan agar gambar tembus
                }}
            ></div>

            {/* KONTEN - tetap di atas */}
            <div className="relative z-10 container mx-auto flex flex-col md:flex-row justify-between items-center text-sm">

                <div className="flex items-center space-x-3 mb-2 md:mb-0">
                    <img
                        src="/images/logo-pemkot-transparan.png"
                        alt="Logo Kota Magelang"
                        className="h-10 w-auto drop-shadow-md"
                    />
                    <div className="font-bold tracking-wide text-white drop-shadow-md">
                        SITUS RESMI BPKAD KOTA MAGELANG
                    </div>
                </div>

                <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-4 font-semibold text-white drop-shadow-md">
                    <a
                        href="https://instagram.com/bpkadmagelang"
                        className="flex items-center hover:text-yellow-300 transition-colors drop-shadow-md"
                    >
                        <FaInstagram className="mr-1" />
                        @bpkadmagelang
                    </a>
                    <a
                        href="mailto:bpkad@magelangkota.go.id"
                        className="flex items-center hover:text-yellow-300 transition-colors drop-shadow-md"
                    >
                        <FaEnvelope className="mr-1" />
                        bpkad@magelangkota.go.id
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Header;